module.exports = __webpack_public_path__ + "img/img-3.a614e83.jpg";